module.exports = __webpack_public_path__ + "assets/img/location2.7a03a24b.png";